import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

export default function Footer() {
  const serviceLinks = [
  { href: '/services#social-media', label: 'Social Media Marketing' },
  { href: '/services#web-dev', label: 'Website Development' },
  { href: '/services#app-dev', label: 'App Development' },
  { href: '/services#design', label: 'Graphic Design' }];


  const companyLinks = [
  { href: '/about', label: 'About Us' },
  { href: '/contact', label: 'Contact' }];


  const resourceLinks = [
  { href: '#', label: 'Blog' },
  { href: '#', label: 'Portfolio' },
  { href: '/privacy-policy', label: 'Privacy Policy' },
  { href: '#', label: 'Terms of Service' }];


  const socialLinks = [
  { href: '#', icon: 'twitter', label: 'Twitter' },
  { href: '#', icon: 'linkedin', label: 'LinkedIn' },
  { href: '#', icon: 'instagram', label: 'Instagram' }];


  return (
    <footer className="relative bg-background border-t border-zinc-800 pt-20 pb-10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div className="bg-zinc-900 border border-zinc-800 rounded-[32px] p-12 md:p-16 lg:p-20">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-8 gap-12 mb-16">
            {/* Company Info */}
            <div className="lg:col-span-3 space-y-6">
              <h3 className="text-2xl font-bold tracking-tight text-[rgba(238,236,236,1)]">
                Classic24 Digital Solutions
              </h3>
              <p className="text-zinc-400 text-sm leading-relaxed max-w-sm">
                Your trusted partner for social media marketing, web development, app development, and graphic design services across all industries.
              </p>
              <div className="space-y-2 text-sm text-zinc-400">
                <p className="flex items-center gap-2">
                  <Icon name="PhoneIcon" size={16} className="text-amber-500" />
                  9763150150 / 9321111170
                </p>
                <p className="flex items-center gap-2">
                  <Icon name="EnvelopeIcon" size={16} className="text-amber-500" />
                  contact@classic24digital.com
                </p>
              </div>
              <div className="flex gap-4">
                {socialLinks?.map((social) =>
                <a
                  key={social?.label}
                  href={social?.href}
                  className="w-10 h-10 rounded-full border border-zinc-800 flex items-center justify-center text-zinc-400 hover:bg-amber-500 hover:text-white hover:border-amber-500 transition-all"
                  aria-label={social?.label}>

                    <span className="text-lg">{social?.icon === 'twitter' ? '𝕏' : social?.icon === 'linkedin' ? 'in' : '📷'}</span>
                  </a>
                )}
              </div>
            </div>

            {/* Links Columns */}
            <div className="lg:col-start-5 lg:col-span-4 grid grid-cols-2 md:grid-cols-3 gap-8">
              <div className="space-y-4">
                <h4 className="text-xs font-bold uppercase tracking-wider text-white">
                  Services
                </h4>
                <ul className="space-y-3 text-sm text-zinc-400">
                  {serviceLinks?.map((link) =>
                  <li key={link?.href}>
                      <Link
                      href={link?.href}
                      className="hover:text-amber-500 transition-colors">

                        {link?.label}
                      </Link>
                    </li>
                  )}
                </ul>
              </div>

              <div className="space-y-4">
                <h4 className="text-xs font-bold uppercase tracking-wider text-white">
                  Company
                </h4>
                <ul className="space-y-3 text-sm text-zinc-400">
                  {companyLinks?.map((link) =>
                  <li key={link?.href}>
                      <Link
                      href={link?.href}
                      className="hover:text-amber-500 transition-colors">

                        {link?.label}
                      </Link>
                    </li>
                  )}
                </ul>
              </div>

              <div className="space-y-4">
                <h4 className="text-xs font-bold uppercase tracking-wider text-white">
                  Resources
                </h4>
                <ul className="space-y-3 text-sm text-zinc-400">
                  {resourceLinks?.map((link) =>
                  <li key={link?.href}>
                      <Link
                      href={link?.href}
                      className="hover:text-amber-500 transition-colors">

                        {link?.label}
                      </Link>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="pt-8 border-t border-zinc-800 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-zinc-500">
            <p>&copy; 2026 Classic24 Digital Solutions. All rights reserved.</p>
            <div className="flex gap-6">
              <Link href="/privacy-policy" className="hover:text-amber-500 transition-colors">
                Privacy Policy
              </Link>
              <Link href="#" className="hover:text-amber-500 transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>

        {/* Giant Background Text */}
        <div className="mt-16 opacity-[0.02] select-none pointer-events-none">
          <h1 className="text-[15vw] font-bold text-white leading-none tracking-tighter text-center">
            CLASSIC24
          </h1>
        </div>
      </div>
    </footer>
  );

}